import { Component } from '@angular/core';

@Component({
  selector: 'cosmos-root',
  template: '<cosmos-root-layout></cosmos-root-layout>',
})
export class AppComponent {
}
